import React, { Component } from "react";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";
import { withRouter } from "react-router-dom";

// Services
import partnersService from '@services/partners';

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { MdVisibility, MdAddCircleOutline } from "react-icons/md";
import ReactTable from "@components/ReactTable";
import Input from "@components/Input";

// Components
import Menu from "@components/Menu";

class Page extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);

    const partners = [{}];

    this.state = {
      table: {
        columns: [
          {
            Header: "Nome",
            accessor: "name",
          },
          {
            Header: "Morada",
            accessor: "address",
          },
          {
            Header: "Telefone",
            accessor: "phone",
          },
          {
            Header: "Email",
            accessor: "email",
          },
          {
            Header: "",
            accessor: "view",
          },
        ],
        rows: [],
        loading: true,
      },
      loaded: false,
      partners,
      search: JSON.parse(localStorage.getItem("partners.search")) || "",
    };
    this.loadFunction = this.loadFunction.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  async loadFunction() {
    if (!this.state.loaded) {
      const { history } = this.props;
      
      try {
        const partners = await partnersService.get(this.props.cookies.get("member_idempresa"));

        const enrichedPartners = partners.map((partner) => ({
          ...partner,
          view: (
            <MdVisibility
              style={{ fontSize: "15px", cursor: "pointer" }}
              onClick={() => history.push(`/partners/${partner.idpartner}`)}
            />
          ),
        }));

        this.setState({
          table: {
            ...this.state.table,
            rows: enrichedPartners,
            loading: false,
          },
          loaded: true,
        });
      } catch (error) {
        console.error(error);
      }
    }
  }

  async removeFunction(data) {
    confirmAlert({
      title: "Confirmação",
      message: `Tem a certeza que deseja apagar o parceiro ${data.name}?`,
      buttons: [
        {
          label: "Sim",
          onClick: async () => {
            try {
              const response = await partnersService.unset(
                this.props.cookies.get("member_idempresa"),
                data.idpartner
              );
              
              if (response !== "NOK") {
                this.setState({
                  partners: this.state.partners.filter(
                    (partner) => partner.idpartner !== data.idpartner
                  ),
                });
              }
            } catch (error) {
              console.error(error);
            }
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  }

  filterData(searchTerm) {
    this.setState({ search: searchTerm });
  }

  handleChange(e, callback) {
    let value = e.target.value;
    let name = e.target.name;

    this.setState({
      [name]: value,
    }, () => {
      switch (name) {
        case "search":
          localStorage.setItem(`partners.${name}`, JSON.stringify(value));
          break;
        default:
          break;
      }
    });
  }

  render() {
    const { table, search } = this.state;
    const { location, history } = this.props;
    const cookies = new URLSearchParams(location.search);

    const filterSearch = search.split(" ");

    const oneOfAll = (partner, search) => {
      const keys = Object.keys(partner);
      return keys.some((key) => `${partner[key] || ''}`.toLowerCase().includes(search.toLowerCase()))
    }

    const tableRows = table.rows.length
      ? table.rows.filter((partner) =>
          filterSearch.every(
            (eachSearch) =>
              eachSearch === "" ||
              oneOfAll(partner, eachSearch)
          )
        )
      : [];

    return (
      <div>
        <Menu
          loadFunction={this.loadFunction}
          location={location}
          history={history}
          newCookies={cookies}
        />
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-xs-12">
            <ol
              style={{
                textAlign: "left",
                marginTop: "75px",
              }}
              className="breadcrumb"
            >
              <li>
                <a href="http://eposgestofinal.com/index.php">Portal</a>
              </li>
              <li className="active">Parceiros</li>
            </ol>
          </div>
        </div>
        <div className="fullContainer" style={{ maxWidth: "100%" }}>
          <div className="col-sm-12" style={{ textAlign: "center" }}>
            <div className="panel panel-default">
              <div
                className="panel-heading"
                style={{
                  fontWeight: "bold",
                  fontSize: "15pt",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: '15px'
                }}
              >
                <div
                  style={{
                    width: "100%",
                    textAlign: "left",
                  }}
                >
                  Parceiros
                </div>
                <div>
                  <table
                    style={{ cursor: "pointer" }}
                    onClick={() => history.push("/partners/new")}
                  >
                    <tr>
                      <td>
                        <MdAddCircleOutline style={{ fontSize: "20px" }} />
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontSize: "xx-small" }}>Criar parceiro</td>
                    </tr>
                  </table>
                </div>
              </div>

              <table className="table table-bordered table-hover table-sortable">
                <thead>
                  <tr>
                    <th className="text-center">Pesquisa</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <Input
                        inputType={"text"}
                        name={"search"}
                        value={search}
                        placeholder="pesquisa..."
                        handleChange={(e) => this.filterData(e.target.value)}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <ReactTable
                columns={table.columns}
                sortable={true}
                loading={table.loading}
                data={tableRows}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withCookies(withRouter(Page));
